// События print-status из Electron не несут идентификатора задания, а
// подписка на них общая для всех монтирований PaymentPage. Если человек ушёл
// с экрана посреди печати («Назад», «На главный экран») и пришёл к оплате
// снова, хвост старого задания (printing → completed) иначе показал бы новому
// заказу «Готово! Заберите документ» прямо поверх неоплаченного QR.
//
// Поэтому после ухода посреди печати события игнорируются, пока старое
// задание не закончится (completed/error) или не начнётся новое (started —
// его Electron шлёт только в начале задания).

let abandonedJob = false;

export function markPrintAbandoned() {
    abandonedJob = true;
}

export function acceptPrintStatus(status) {
    if (!abandonedJob) return true;
    if (status === "started") {
        abandonedJob = false;
        return true;
    }
    if (status === "completed" || status === "error") abandonedJob = false;
    return false;
}

// Для тестов: модульное состояние живёт между тестами одного файла.
export function resetPrintSession() {
    abandonedJob = false;
}
